import React from 'react';
import styled from 'styled-components';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';

const DrawerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.25);
  z-index: 1000;
  display: ${({ open }) => (open ? 'block' : 'none')};
`;

const Drawer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 370px;
  height: 100vh;
  background: #fffbe6;
  box-shadow: -2px 0 16px rgba(0,0,0,0.13);
  z-index: 1100;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s cubic-bezier(.4,0,.2,1);
  display: flex;
  flex-direction: column;
`;
const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 1.5rem 1rem 1.5rem;
  border-bottom: 1px solid #eee;
`;
const DrawerTitle = styled.h2`
  font-size: 1.3rem;
  font-weight: 700;
`;
const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.7rem;
  cursor: pointer;
`;
const CartList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1.2rem 1.5rem;
`;
const CartItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.2rem;
`;
const ItemInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
const ItemImage = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
  border-radius: 8px;
`;
const ItemName = styled.div`
  font-weight: 600;
  font-size: 1rem;
`;
const ItemWeight = styled.div`
  color: #888;
  font-size: 0.95rem;
`;
const ItemPrice = styled.div`
  font-weight: 700;
  color: #FF6B00;
  min-width: 60px;
  text-align: right;
`;
const QuantityControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;
`;
const QuantityButton = styled.button`
  background: #FF6B00;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 1.1rem;
  cursor: pointer;
  &:disabled { opacity: 0.5; }
`;
const RemoveButton = styled.button`
  background: #eee;
  color: #FF6B00;
  border: none;
  border-radius: 6px;
  padding: 0.2rem 0.7rem;
  font-size: 0.9rem;
  cursor: pointer;
`;
const DrawerFooter = styled.div`
  padding: 1.2rem 1.5rem;
  border-top: 1px solid #eee;
`;
const Total = styled.div`
  text-align: right;
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;
const CheckoutButton = styled.button`
  width: 100%;
  background: #006400;
  color: white;
  border: none;
  padding: 1rem 0;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  &:hover { background: #004d00; }
`;

export default function SideCartDrawer({ open, onClose }) {
  const { cart, updateQuantity, removeFromCart } = useCart();
  const navigate = useNavigate();
  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  const handleCheckout = () => {
    onClose();
    navigate('/checkout');
  };

  return (
    <>
      <DrawerOverlay open={open} onClick={onClose} />
      <Drawer open={open}>
        <DrawerHeader>
          <DrawerTitle>Coșul tău</DrawerTitle>
          <CloseButton onClick={onClose} title="Închide">×</CloseButton>
        </DrawerHeader>
        <CartList>
          {cart.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#888', marginTop: '2rem' }}>Coșul este gol.</div>
          ) : (
            cart.map(item => (
              <CartItem key={item.name + item.weight}>
                <ItemInfo>
                  <ItemImage src={item.image} alt={item.name} />
                  <div>
                    <ItemName>{item.name}</ItemName>
                    <ItemWeight>{item.weight} g</ItemWeight>
                  </div>
                </ItemInfo>
                <ItemPrice>{(item.price * item.quantity).toFixed(2)} LEI</ItemPrice>
                <QuantityControls>
                  <QuantityButton onClick={() => updateQuantity(item, item.quantity - 1)} disabled={item.quantity <= 1}>-</QuantityButton>
                  <span>{item.quantity}</span>
                  <QuantityButton onClick={() => updateQuantity(item, item.quantity + 1)}>+</QuantityButton>
                </QuantityControls>
                <RemoveButton onClick={() => removeFromCart(item)}>×</RemoveButton>
              </CartItem>
            ))
          )}
        </CartList>
        <DrawerFooter>
          <Total>Total: {total.toFixed(2)} LEI</Total>
          <CheckoutButton onClick={handleCheckout} disabled={cart.length === 0}>
            Oferă comanda
          </CheckoutButton>
        </DrawerFooter>
      </Drawer>
    </>
  );
}